<template>
  <v-container
    fluid
    class="transporter-details-page ops-entry-form-page ops-entry-form-page--transporter ops-entry-form-page--edit"
  >
    <v-card raised class="transporter-details-card ops-entry-form-card">
      <loading :active.sync="loading" />
      <v-card-text class="transporter-details-body content-border">
        <v-tabs
          class="m-b-20 customer-details-tabs transporter-details-tabs"
          v-model="changeTabListing"
        >
          <v-tab
            :href="`#basicDetail`"
            class="customer-details-tab transporter-details-tab"
            @click="filterByTab('basicDetail')"
          >
            <v-icon small class="customer-details-tab__icon">
              business
            </v-icon>
            <span class="customer-details-tab__label">Basic Details</span>
          </v-tab>
          <v-tab
            v-if="transporterType == '1' && $route.params.isVerified == 'true'"
            :href="`#drivers`"
            class="customer-details-tab transporter-details-tab"
            @click="
              filterByTab('drivers');
              $router.push(
                `/transporter/driver/${$route.params.id}/${$route.params._id}/${$route.params.country}`
              );
            "
          >
            <v-icon small class="customer-details-tab__icon">
              group
            </v-icon>
            <span class="customer-details-tab__label">Drivers</span>
          </v-tab>
        </v-tabs>

        <div class="transporter-details-view">
          <EditTransporter
            v-if="changeTabListing == 'basicDetail'"
            v-on:transporter-type="type"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { EventBus } from "../../event-bus.js";
import EditTransporter from "./EditTransporter";
import moment from "moment";
import Loading from "vue-loading-overlay";
import { StorageKeys } from "../../constants/constants";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      let workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          this.invoicingCountry = key.value;
        }
      });
    }
    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "transporter-detail") {
        this.$router.push(`/transporter`);
      }
    });

    this.$eventBus.$on("on-load", () => {
      this.loading = true;
    });
    this.$eventBus.$on("transporter-type", (event) => {
      this.transporterType = event;
    });

    this.$eventBus.$on("off-load", () => {
      this.loading = false;
    });
  },

  mounted() {},
  components: {
    Loading,
    EditTransporter,
  },

  data: () => ({
    search: "",
    country: "",
    transporterType: "",
    active: "0",
    dialog: false,
    reset: false,
    loading: false,
    changeTabListing: "basicDetail",
  }),
  methods: {
    type(event) {},
    goback() {
      this.$router.go(-1);
    },
    filterByTab(value) {
      this.changeTabListing = value;
    },
    startLoad() {
      this.loading = true;
    },
    stopLoad() {
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.m-b-20 {
  margin-bottom: 20px !important;
}
</style>
